import type { AxiosError } from 'axios';
import { isAxiosError } from 'axios';

export function isAxiosNotFoundError(error: unknown): boolean {
    const axiosError = error as AxiosError;
    return axiosError?.response?.status === 404;
}

export function getAxiosErrorMessage(error: unknown, fallback = 'Something went wrong!'): string {
    const axiosError = error as AxiosError<string>;
    return axiosError?.response?.data || fallback;
}

export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
    if (isAxiosNotFoundError(error)) return false;
    return failureCount < 3;
}

/**
 * Whether a client form load/access failure is worth offering a Retry button.
 * Network/timeouts/5xx/429/408 are retryable; 404 and other 4xx are terminal.
 */
export function isRetryableClientLoadError(error: unknown): boolean {
    if (!isAxiosError(error)) {
        // Non-Axios failures (e.g. unexpected throw) — allow Retry.
        return true;
    }

    // No response: network error, DNS failure, or timeout.
    if (!error.response) {
        return true;
    }

    const status = error.response.status;
    if (status === 404) return false;
    if (status === 408 || status === 429 || status >= 500) return true;
    if (status >= 400 && status < 500) return false;

    return true;
}
